/**
 * Updates the content of the nearest <small> element with the attribute data-product
 * to match the value of the data-gift-card attribute from the target element.
 *
 * @param {HTMLElement} target - The target element containing the data-gift-card and data-product attributes.
 */
export var productVariantSwatchesPrices = function productVariantSwatchesPrices(target) {
  var giftCardValue = target.getAttribute('data-gift-card');
  var productId = target.getAttribute('data-product');
  var labelPrice = document.querySelector("small[data-product=\"".concat(productId, "\"]"));
  if (labelPrice) {
    labelPrice.textContent = giftCardValue;
  }
};